import type React from 'react';

import { PageMeta } from '../components/PageMeta';
import { ProfileCardWrapper } from '../components/ProfileCardWrapper';
import { ResponseListWrapper } from '../components/ResponseListWrapper';
import { SapToDm } from '../components/SapToDm';
import { TargetedPetitionListWrapper } from '../components/TargetedPetitionListWrapper';
import { TopIssues } from '../components/TopIssues';
import { WebsitesContainer } from '../components/Websites';

import { useLayout } from './hooks/useLayout';

export const Layout: React.FC = () => {
	const {
		data: { showSapContainer, isDmrlEnabled },
	} = useLayout();

	return (
		<>
			<PageMeta />

			<div className="container pb-24">
				<ProfileCardWrapper />
				{isDmrlEnabled && (
					<>
						<WebsitesContainer />
						<TopIssues />
					</>
				)}

				<div className="overflow-x-hidden px-4 md:px-0">
					<TargetedPetitionListWrapper />

					{showSapContainer && (
						<div className="mb-8">
							<SapToDm />
						</div>
					)}

					<ResponseListWrapper />
				</div>
			</div>
		</>
	);
};
